export enum LengthType {
	Manual = 'manual',
	Offers = 'offers',
}

export enum Terms {
	CashDown = 'down',
	Length = 'termLength',
	Miles = 'programMiles',
}
